"use client";

import Script from "next/script";
import { CONSENT_SCRIPT } from "@/lib/consent/cookie-consent";
import { getPrivacyBootstrapScript } from "@/lib/consent/privacy";
import "@/components/consent/cookie-consent.css";

declare global {
  interface Window {
    acceptCookieConsent?: () => void;
    declineCookieConsent?: () => void;
    blockAnalytics?: boolean;
    gtag?: (...args: unknown[]) => void;
    __xPixelInitialized?: boolean;
    twq?: ((...args: unknown[]) => void) & { queue?: unknown[] };
  }
}

export default function ConsentManager() {
  return (
    <>
      {/* Cookie Consent Script - Loaded from external file */}
      <Script
        id="cookie-consent"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: getPrivacyBootstrapScript() + CONSENT_SCRIPT,
        }}
      />
    </>
  );
}
